import GetCurrentProgressScreen from './get-current-progress';

export default GetCurrentProgressScreen;
